import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CTypeaheadComponent } from './c-typeahead.component';
import { IonicModule } from '@ionic/angular';



@NgModule({
  declarations: [CTypeaheadComponent],
  imports: [
    CommonModule,
    IonicModule,
  ],
  exports: [CTypeaheadComponent]
})
export class CTypeaheadModule { }
